import type { CSSProperties, ReactNode } from 'react';
import { clsx } from 'clsx';
import { marketingFontVariables } from './fonts';
import styles from './marketing.module.css';

interface MarketingSurfaceProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

/**
 * The root of every redesigned marketing page. Carries the Part 1 design-system
 * tokens so every descendant resolves `var(--…)`, and paints the soft-white page
 * so no section has to. One wrapper per page, never nested.
 *
 * It also carries the two font variables the tokens read, which is what scopes
 * their preload to the routes that render this surface rather than every page
 * in the app.
 */
export function MarketingSurface({
  children,
  className,
  style,
}: MarketingSurfaceProps): React.ReactElement {
  return (
    <div
      className={clsx(styles.surface, marketingFontVariables, className)}
      style={style}
    >
      {children}
    </div>
  );
}
